import 'slick-carousel/slick/slick'

export default class FeaturedKnowledgeBankSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-featured-kb-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                prevArrow: $('.js-featured-kb-slider-previous'),
                nextArrow: $('.js-featured-kb-slider-next'),
                appendDots: $('.js-featured-kb-slider-dots')
            });
        }

    }

};

new FeaturedKnowledgeBankSlider();